import { Reveal } from '../components/Reveal';
import { LAYERS } from '../data/layers';

export function Vision() {
  return (
    <section className="block" id="manifeste" data-screen-label="06 Vision">
      <div className="wrap">
        <div className="sec-head">
          <div><div className="sec-num"><b>06</b> &nbsp; horizon</div></div>
          <div className="sec-tag">ROADMAP / PROTOCOLE</div>
        </div>
        <div className="vision-block">
          <div className="vision-head">
            <Reveal as="h2">Aujourd'hui un fil. <em>Demain, un protocole.</em></Reveal>
            <div className="vision-body">
              <Reveal as="p">
                <b>furtif.fm commence par un réseau social musical cross-plateforme.</b> La destination est plus large : un graphe social musical ouvert qui relie l'écoute, les concerts, les festivals, les disquaires, les artistes.
              </Reveal>
              <Reveal as="p">
                À terme — un protocole décentralisé pour faire circuler la musique entre humains, <b>sans que personne ne possède le réseau</b>. Pas même nous.
              </Reveal>
              <a
                href="/manifesto.html"
                className="ulink"
                style={{ marginTop: '1.75rem', display: 'inline-flex', gap: '.4rem', alignItems: 'center' }}
              >Lire le manifeste complet &nbsp;→</a>
            </div>
          </div>
          <Reveal className="layers">
            {LAYERS.map((l) => (
              <div key={l.ix} className={`layer ${l.cls}`}>
                <span className="ix">{l.ix}</span>
                <div>
                  <div className="nm">{l.nm}</div>
                  <div className="desc">{l.desc}</div>
                </div>
                <span className="st">{l.st}</span>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
